import { buildApiUrl } from "../../../config.js";
import React, { useState, useEffect } from "react";
import { FaEdit, FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";

const EditSupplierModal = ({ supplier, onClose, onSubmit }) => {
  const [supplierName, setSupplierName] = useState(supplier.supplierName || "");
  const [contactPersonName, setContactPersonName] = useState(
    supplier.contactPersonName || ""
  );
  const [email, setEmail] = useState(supplier.email || "");
  const [address, setAddress] = useState(supplier.address || "");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setSupplierName(supplier.supplierName);
    setContactPersonName(supplier.contactPersonName);
    setEmail(supplier.email);
    setAddress(supplier.address);
  }, [supplier]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const token = localStorage.getItem("token");
    try {
      const response = await fetch(
        buildApiUrl(`/api/supplier/suppliers/${supplier._id}`),
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            supplierName,
            contactPersonName,
            email,
            address,
          }),
        }
      );

      if (response.ok) {
        toast.success("Supplier updated successfully!");
        onSubmit();
        onClose();
      } else {
        toast.error("Failed to update supplier.");
      }
    } catch (error) {
      toast.error("An error occurred while updating the supplier.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-70 z-50 transition-opacity duration-300">
      <div className="bg-white rounded-lg shadow-2xl w-full max-w-sm mx-4 p-4 transform transition-all duration-300 scale-100">
        <div className="flex items-center justify-between border-b border-gray-200 pb-2">
          <div className="flex items-center gap-2">
            <FaEdit className="text-indigo-600" size={16} />
            <h2 className="text-lg font-semibold text-gray-800">
              Edit Supplier
            </h2>
          </div>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <FaTimes size={16} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="mt-3 space-y-3">
          <div>
            <label
              htmlFor="supplierName"
              className="block text-xs font-medium text-gray-600 mb-1"
            >
              Supplier Name
            </label>
            <input
              type="text"
              id="supplierName"
              value={supplierName}
              onChange={(e) => setSupplierName(e.target.value)}
              required
              className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            />
          </div>

          <div>
            <label
              htmlFor="contactPersonName"
              className="block text-xs font-medium text-gray-600 mb-1"
            >
              Contact Person Name
            </label>
            <input
              type="text"
              id="contactPersonName"
              value={contactPersonName}
              onChange={(e) => setContactPersonName(e.target.value)}
              required
              className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            />
          </div>

          <div>
            <label
              htmlFor="email"
              className="block text-xs font-medium text-gray-600 mb-1"
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            />
          </div>

          <div>
            <label
              htmlFor="address"
              className="block text-xs font-medium text-gray-600 mb-1"
            >
              Address
            </label>
            <input
              type="text"
              id="address"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              required
              className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            />
          </div>

          <div className="flex justify-end items-center pt-3 border-t border-gray-200 gap-2">
            <button
              type="button"
              onClick={onClose}
              className="px-3 py-2 bg-gray-200 text-gray-700 text-xs rounded-md hover:bg-gray-300 transition-colors duration-200"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-3 py-2 bg-indigo-600 text-white text-xs rounded-md hover:bg-indigo-800 transition-colors duration-200 flex items-center gap-1 disabled:bg-gray-400"
            >
              <FaEdit size={12} />
              {loading ? "Updating..." : "Update Supplier"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default React.memo(EditSupplierModal);
